module.exports = __webpack_public_path__ + "img/token-hunt-variant-2.f1884b90.webp";